module.exports = __webpack_public_path__ + "static/media/eeri_logo_square_2019_2.5x2.5.fdc71a73.png";